module.exports = __webpack_public_path__ + "img/浓雾.6ae3c570.png";